import React from "react";
import "../../../styles/main.css";
import PageHeader from "../../../components/reusable/ModuleHeader/PageHeader";
import Breadcrumb from "../../../components/reusable/ModuleHeader/Breadcrumb";
import Subpage_110 from "../../../modules/caneva/Subpage_110";



const Page_110 = () => {
  return (
    <div
      style={{
        padding: 0,
        margin: 0,
        boxSizing: "border-box",
        minWidth: 1200,   // largeur logique de page
      }}
    >
      <Breadcrumb
        items={[
          { label: "homepage", href: "/Homepage" },
          { label: "caneva / timeline", href: "/page_110" },
        ]}
      />

      {/* <PageHeader
        title=""
        className="title-caneva"
      /> */}

      {/* <hr className="page-separator" /> */}

      <main
        className="content"
        style={{
          padding: 0,
          margin: 0,
          background: "transparent",
          boxSizing: "border-box",
        }}
      >
        <Subpage_110 />
      </main>
    </div>
  );
};

export default Page_110;
